import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../components/SafetyInspection.css';

const pub = process.env.PUBLIC_URL;

export default function SafetyInspection() {
  useEffect(() => {
    AOS.init({ duration: 700, once: false, delay: 50 });
  }, []);

  const features = [
    'Comprehensive electrical safety audits',
    'Load analysis & distribution evaluation',
    'Grounding & insulation resistance tests',
    'Thermal imaging & infrared inspections',
    'Emergency & exit lighting checks',
    'Full compliance reporting',
  ];

  const benefits = [
    {
      icon: 'fas fa-check-circle',
      title: 'Regulatory Compliance',
      text: 'Meets SANS, IEC & local municipal standards to keep you fully legal.',
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'Risk Mitigation',
      text: 'Identify and eliminate hidden hazards before they become incidents.',
    },
    {
      icon: 'fas fa-clock',
      title: 'Minimized Downtime',
      text: 'Proactive maintenance planning keeps your operations running smoothly.',
    },
  ];

  const faqs = [
    {
      q: 'How often should I schedule an inspection?',
      a:
        'We recommend annual inspections for most sites, or more frequently if regulations or usage demand it.',
    },
    {
      q: 'What standards do you follow?',
      a:
        'Our inspections adhere to SANS 10142-1, IEC regulations and any specific local bylaws.',
    },
    {
      q: 'Can you provide detailed compliance reports?',
      a:
        'Yes—after each inspection you receive a full written report with findings, photos and remediation advice.',
    },
  ];

  return (
    <>
      {/* Hero */}
      <section
        className="hero-section"
        data-aos="fade-up"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.7)), url(${pub}/front3.jpg)`,
        }}
      >
        <div className="hero-content">
          <h1>Safety Inspection &amp; Compliance</h1>
          <p>
            Comprehensive electrical safety inspections to protect your property and
            ensure full regulatory compliance.
          </p>
          <div className="hero-buttons">
            <a href="#service-intro" className="btn">
              Learn More
            </a>
            <a href="#contact" className="btn btn-outline">
              Request Inspection
            </a>
          </div>
        </div>
      </section>

      {/* Service Intro */}
      <section className="service-intro" id="service-intro" data-aos="fade-up">
        <div className="service-intro-content">
          <div className="service-intro-image" data-aos="fade-right">
            <img
              src={`${pub}/front3.jpg`}
              alt="Electrical Safety Inspection"
            />
          </div>
          <div className="service-intro-text" data-aos="fade-left">
            <h2>Why Electrical Safety Matters</h2>
            <p>
              At Mosike Electrical Contractors, our certified electricians conduct
              in-depth inspections to identify hazards, verify code compliance,
              and give you the peace of mind that your installation is safe and reliable.
            </p>
            <ul className="service-features">
              {features.map((feat, i) => (
                <li key={i}>
                  <i className="fas fa-check-circle" /> {feat}
                </li>
              ))}
            </ul>
            <a href="#contact" className="btn">
              Schedule Your Inspection
            </a>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="service-benefits" data-aos="fade-up">
        <h2 className="section-title">Benefits of Our Safety Inspections</h2>
        <p className="section-description">
          Proactive safety checks deliver real value to your operation.
        </p>
        <div className="benefits-grid">
          {benefits.map((b, i) => (
            <div className="benefit-card" key={i}>
              <div className="benefit-icon">
                <i className={b.icon} />
              </div>
              <div className="benefit-content">
                <h3>{b.title}</h3>
                <p>{b.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ 
      <section className="faq-section" data-aos="fade-up">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <div className="faq-container">
          {faqs.map((f, i) => (
            <div className="faq-item" key={i} data-aos="fade-up" data-aos-delay={(i + 1) * 100}>
              <div className="faq-question">
                <span>{f.q}</span> <i className="fas fa-chevron-down" />
              </div>
              <div className="faq-answer">
                <p>{f.a}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
*/}
      {/* CTA */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-content">
          <h2>Ready to Ensure Your Safety?</h2>
          <p>
            Contact us today to book your full electrical safety inspection and
            compliance report.
          </p>
          <div className="cta-buttons">
            <a href="tel:+1234567890" className="btn btn-white">
              <i className="fas fa-phone" /> Call Now
            </a>
            <a href="#contact" className="btn btn-outline">
              <i className="fas fa-envelope" /> Email Us
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
